import BaseFormView, {BaseFormViewState} from "../../../../ui/form/BaseFormView";
import SerialNumbersData from "../../../../../model/job/SerialNumbersData";
import * as React from "react";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import {Option} from "ts-option";
import WarrantyInfoFormBody from "../WarrantyInfoFormBody";
import WarrantyInfoData from "../../WarrantyInfoData";
import WarrantyInfoFrom from "../WarrantyInfoFrom";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {data} new warranty info data.
	 */
	onSubmit: (data: WarrantyInfoData) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * On export CSV button handler.
	 */
	onExportCSV: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Serial numbers to edit.
	 */
	serialNumbers: Option<SerialNumbersData>;
	/**
	 * Contact title to edit
	 */
	title: Option<string>;
	/**
	 * Merchant id to edit
	 */
	merchantId: Option<string>;
	/**
	 * Is Job with quote
	 */
	isJobWithQuote: boolean
}

interface ComponentState {
	isFormValid: boolean
}

type IState = BaseFormViewState<WarrantyInfoFrom> & ComponentState;

export default class EditWarrantyInfoFormView extends BaseFormView<WarrantyInfoFrom, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: WarrantyInfoFrom.createFormWarrantyInfo(props.serialNumbers, props.title, props.merchantId),
			isFormDirty: false,
			shouldValidate: false,
			isFormValid: false
		}
	}

	componentDidMount(): void {
		const validatedForm = this.state.form.validate();
		validatedForm.onValid(() => {this.setState({isFormValid: true})}, () => {});
	}

	render() {
		return (
			<div>
				<WarrantyInfoFormBody form={this.state.form}
									  onFieldChange={this.onFieldChanged}
									  onFieldCompleted={this.onFieldCompleted}
									  onFocusChange={this.onFocusChange}
									  onFieldsChange={this.onFieldsChanged}/>
				{this.getFormActions()}
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid((data) => {
				this.setState({isFormValid: true, isFormDirty: false});
				this.props.onSubmit(data);
			}, () => {});
		});
	}

	getFormActions() {
		if (this.state.isFormDirty || !this.state.isFormValid || this.props.isSubmitting) {
			return (
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Save"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			);
		}
		else {
			return (
				<FormButtonsView align={"right"}>
					{this.props.isJobWithQuote &&
					<div style={{float: 'left'}}>
						<ButtonTertiary onClick={this.props.onExportCSV}
										label={"Export as CSV"}
										disabled={this.props.isSubmitting}/>
					</div>
					}
					<ButtonPrimary onClick={this.props.onCancel}
								   label={"Done"}
								   disabled={this.props.isSubmitting}/>
				</FormButtonsView>
			);
		}
	}
}